import openChat from 'utils/open-chat'

const defineLocalizationForm = () => {
  if (customElements.get('localization-form')) {
    return
  }

  class LocalizationForm extends HTMLElement {
    constructor () {
      super()

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul')
      }

      if (!this.elements.input || !this.elements.button || !this.elements.panel) {
        return
      }

      this.elements.button.addEventListener('click', this.openSelector.bind(this))
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this))
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

      for (const item of this.querySelectorAll('a')) {
        item.addEventListener('click', this.onItemClick.bind(this))
      }
    }

    hidePanel () {
      this.elements.button.setAttribute('aria-expanded', 'false')
      this.elements.panel.setAttribute('hidden', true)
    }

    onContainerKeyUp (event) {
      if (event.code.toUpperCase() !== 'ESCAPE') {
        return
      }

      this.hidePanel()
      this.elements.button.focus()
    }

    onItemClick (event) {
      event.preventDefault()

      const form = this.querySelector('form')

      this.elements.input.value = event.currentTarget.dataset.value

      if (form) {
        form.submit()
      }
    }

    openSelector () {
      this.elements.button.focus()
      this.elements.panel.toggleAttribute('hidden')
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString())
    }

    closeSelector (event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'

      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel()
      }
    }
  }

  customElements.define('localization-form', LocalizationForm)
}

export default el => {
  defineLocalizationForm()

  const backToTop = el.querySelector('.js-back-to-top')
  const newsletterMessage = el.querySelector('[data-newsletter-message]')
  const triggerButtons = el.querySelectorAll('[data-trigger-selector]')
  const shippingSelectorTrigger = el.querySelector('[data-shipping-selector-trigger]')
  const shippingSelectorModal = el.querySelector('[data-shipping-selector-modal]')

  if (shippingSelectorTrigger && shippingSelectorModal) {
    const shippingSelectorCloseButtons = shippingSelectorModal.querySelectorAll('[data-shipping-selector-close]')
    const shippingSelectorInput = shippingSelectorModal.querySelector('[data-shipping-selector-input]')
    let lastFocusedElement = null

    const closeShippingSelector = () => {
      shippingSelectorModal.hidden = true
      shippingSelectorModal.setAttribute('aria-hidden', 'true')
      shippingSelectorTrigger.setAttribute('aria-expanded', 'false')
      document.body.classList.remove('redesign-shipping-modal-open')

      if (lastFocusedElement) {
        lastFocusedElement.focus()
      }
    }

    const openShippingSelector = () => {
      lastFocusedElement = document.activeElement
      shippingSelectorModal.hidden = false
      shippingSelectorModal.setAttribute('aria-hidden', 'false')
      shippingSelectorTrigger.setAttribute('aria-expanded', 'true')
      document.body.classList.add('redesign-shipping-modal-open')

      if (shippingSelectorInput) {
        shippingSelectorInput.focus()
      }
    }

    shippingSelectorTrigger.addEventListener('click', openShippingSelector)

    for (const button of shippingSelectorCloseButtons) {
      button.addEventListener('click', closeShippingSelector)
    }

    shippingSelectorModal.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault()
        closeShippingSelector()
        return
      }

      if (event.key !== 'Tab') return

      const focusableElements = shippingSelectorModal.querySelectorAll('button:not([disabled]), select:not([disabled])')
      const firstFocusableElement = focusableElements[0]
      const lastFocusableElement = focusableElements[focusableElements.length - 1]

      if (!firstFocusableElement || !lastFocusableElement) return

      if (event.shiftKey && document.activeElement === firstFocusableElement) {
        event.preventDefault()
        lastFocusableElement.focus()
      } else if (!event.shiftKey && document.activeElement === lastFocusableElement) {
        event.preventDefault()
        firstFocusableElement.focus()
      }
    })
  }

  if (backToTop) {
    backToTop.addEventListener('click', () => {
      ;(document.scrollingElement || document.documentElement).scrollTo({ top: 0, behavior: 'smooth' })
    })
  }

  if (newsletterMessage) {
    newsletterMessage.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  for (const button of triggerButtons) {
    button.addEventListener('click', () => {
      const selector = button.dataset.triggerSelector

      if (!selector) {
        return
      }

      if (selector === '.online-chat' && openChat()) {
        return
      }

      const target = document.querySelector(selector)

      if (target && target !== button) {
        target.click()
      }
    })
  }
}
